import { render, staticRenderFns } from "./fraudcasesDis.vue?vue&type=template&id=70213bb7"
import script from "./fraudcasesDis.vue?vue&type=script&lang=js"
export * from "./fraudcasesDis.vue?vue&type=script&lang=js"
import style0 from "./fraudcasesDis.vue?vue&type=style&index=0&id=70213bb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports